// Chakra imports
import { Text, useColorModeValue } from "@chakra-ui/react";
// Assets
import Project1 from "assets/images/imageHolder.png";
import Project2 from "assets/images/bajaji.jpeg";
import Project3 from "assets/images/pepsi.jpg";
// Custom components
import Card from "components/card/Card";
import Project from "views/site/BandaReservations/components/Project";
import { useState } from "react";
import { useGetBandaReservationsQuery } from "generated/graphql";
import { useSelector } from "react-redux";

export default function Projects(props: { [x: string]: any }) {
  const { ...rest } = props;
  // Chakra Color Mode
  const textColorPrimary = useColorModeValue("secondaryGray.900", "white");
  const textColorSecondary = "gray.400";
  const cardShadow = useColorModeValue(
    "0px 18px 40px rgba(112, 144, 176, 0.12)",
    "unset"
  );

  const { user }: IUser | any = useSelector((state: UserState) => state.user);
  // console.log(user);
  // console.log(user);

  // GetBandaReservations
  const [page, setPage] = useState(1);
  const [pageTemp, setPageTemp] = useState(1);
  const [pageSize, setPageSize] = useState(9);
  const [category, setCategory] = useState("PROMO");

  const reservationData = useGetBandaReservationsQuery({
    fetchPolicy: "cache-first",
    variables: {
      getEventsInput: {
        userId: user.id,
        page,
        pageSize,
        category,
      },
    },
  });

  // console.log(reservationData);

  return (
    <Card mb={{ base: "0px", "2xl": "20px" }} {...rest}>
      <Text
        color={textColorPrimary}
        fontWeight="bold"
        fontSize="2xl"
        mt="10px"
        mb="4px"
      >
        Promo
      </Text>
      <Card mb={{ base: "0px", "2xl": "20px" }} maxHeight={"650px"} overflowX={"auto"}>

      {/* <Text color={textColorSecondary} fontSize="md" me="26px" mb="40px">
        Promo deals : get by date, week etc ! most recently
      </Text> */}
      {reservationData?.data?.getBandaReservations.map((item) => {
        return (
          <Project
            boxShadow={cardShadow}
            mb="20px"
            image={Project1}
            ranking={item.createdAt}
            link={item?.event?.title}
            title={item?.title}
          />
        );
      })}
    </Card>
    </Card>
  );
}
